const GradientBorderButton = (props) => {
    const { customClass, buttonType, title, children, disabled, onClick, parentClass } = props
    return (
        <button
            type={buttonType}
            disabled={disabled}
            onClick={onClick}
            className={`${parentClass} h-11 bg-gradient-to-br from-primary to-accent p-[1.5px] rounded-full group transition-all duration-200 hover:shadow-float hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary/25 disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:translate-y-0`}
        >
            <span
                className={`${customClass} flex h-full w-full items-center justify-center bg-white rounded-full px-5 text-sm font-semibold text-neutral-900 group-hover:bg-gradient-to-br group-hover:from-primary group-hover:to-accent group-hover:text-white transition-all duration-200 ${disabled ? "cursor-not-allowed" : ""}`}
            >
                {children ? children : title}
            </span>
        </button>
    )
}

export default GradientBorderButton
